import styled from 'styled-components';
import { theme } from 'shared/themes/aplant.theme';

export const AssignedProfileListContainer = styled.div`
  margin: 15px 0;
  
  &:hover{
    background-color: ${theme.palette.gray["100"]};
  }
`;